import { render } from "./ViewResults.vue?vue&type=template&id=7855dcac"
import script from "./ViewResults.vue?vue&type=script&lang=js"
export * from "./ViewResults.vue?vue&type=script&lang=js"

import exportComponent from "/home/teo/git_repos/cancer-classifier-app/cancer-classifier-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__